import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DbStoreState } from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getVibeFilesState = createSelector(
  getDbStoreState,
  (dbStoreState: DbStoreState) => dbStoreState.vibeFiles
);

// Selector for request status per domainId
export const getVibeFilesStatus = (domainId: number) =>
  createSelector(getVibeFilesState, (state: any) => {
    if (state.loading?.[domainId]) return 'loading';
    if (state.error?.[domainId]) return 'fail';
    if (state.data?.[domainId]) return 'success';
    return 'idle';
  });
